import { useHistory } from "react-router";
import staticImg from "../../../assets/images/user-image.png";
import { useSelector } from "react-redux";

const UserMenu = ({ menuOpen, setMenuOpen, menuRef, handleLogout, isAuthenticated }) => {
    const userDetail = useSelector(state => state.userDetailsReducer)
    const history = useHistory()
    return (
        <div className="profile_name_img_links">
            <div onClick={() => setMenuOpen(!menuOpen)} className="header_profile">
                {isAuthenticated && (
                    <>
                        <span className="user_name">{userDetail.first_name ? `${userDetail.first_name || ''} ${userDetail.last_name || ''}` : 'Admin'}</span>
                        <span className="user_profile_pic cursor_pointer"><img src={userDetail.profile ? userDetail.profile : staticImg} alt="Profile picture" /></span>
                    </>
                )}
                {
                    isAuthenticated && (
                        <ul ref={menuRef} className="dropdown-menu list-unstyled">
                            <li><span onClick={() => history.push('/my-profile')}>My Profile</span></li>
                            <li><span onClick={() => history.push('/settings')}>Settings</span></li>
                            <li><span onClick={() => handleLogout()}>Log Out</span></li>
                        </ul>
                    )
                }
            </div>
        </div>
    )
};

export default UserMenu